export const APP_CONFIG = {
    API_URL: process.env.REACT_APP_API_BASE_URL + '/v1',
    SOCKET_URL: process.env.REACT_APP_API_BASE_URL,
    ESCROW_URL: process.env.REACT_APP_ESCROW_URL,
}